"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smallSelectStyle = void 0;
const theme_1 = require("../../theme");
exports.smallSelectStyle = {
    control: (baseStyles) => ({
        ...baseStyles,
        width: 180,
        fontSize: theme_1.theme.fontSizeNumber(-1),
        minHeight: "30px",
        height: "30px",
        border: "none",
        boxShadow: "none",
    }),
    input: (baseStyles) => ({
        ...baseStyles,
        fontSize: theme_1.theme.fontSizeNumber(-1),
        textTransform: "uppercase",
        fontWeight: "bold",
    }),
    singleValue: (baseStyles) => ({
        ...baseStyles,
        fontSize: theme_1.theme.fontSizeNumber(-1),
        textTransform: "uppercase",
        fontWeight: "bold",
    }),
    valueContainer: (provided, _state) => ({
        ...provided,
        height: "30px",
    }),
};
